import { checkAuthorized, returnJsonResponse, withAuth } from "./AuthenticationService";
import { createParams } from "./CommonService";
import { BACKEND_URL } from "./BackendConfig";

export const createTag = async (data) => {
    const response = await fetch(`${BACKEND_URL}/tags`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
        credentials: 'include'
    });
    await checkAuthorized(response);
    return await returnJsonResponse(response);
}

export const fetchTagsByFilter = async (data) => {
    const response = await fetch(`${BACKEND_URL}/tags${createParams(data)}`, { credentials: 'include' });
    await checkAuthorized(response);
    return await returnJsonResponse(response);
}

export const securedCreateTag = withAuth(createTag);
export const securedFetchTagsByFilter = withAuth(fetchTagsByFilter);